import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import LatinExt from "./WorkSans-Regular-QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXBiAJpo3ZKyHaQfhf.woff2";
import Latin from "./WorkSans-Regular-QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXBiEJpo3ZKyHaQfhf.woff2";

export const WorkSansFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LatinExt,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT,
      weight: "400",
    },
  },
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
